module.exports = __webpack_public_path__ + "img/oh-sl-logo.b196528a.png";